<template>
  <div
    class="tab-pane fade"
    id="unsplash-tab-pane"
    role="tabpanel"
    aria-labelledby="unsplash-tab"
    tabindex="0"
  >
    <div class="theme-tab-inner">
      <div class="image-search">
        <input
          placeholder="Search Library..."
          class="search-library-input"
          @keyup="searchUnsplash"
          v-model="unsplashSearch"
          maxlength="45"
          type="text"
        />
        <div id="unsplashApiSearchLoader" class="loader hidden"></div>
      </div>
      <ul v-if="unsplash" class="giphy-col">
        <li v-for="(item, index) in usplashData">
          <a href="javascript:void(0)" @click="handleClick(item.urls.small)">
            <div class="position-relative">
              <img :src="item.urls.small" alt="GIF image" />
              <span class="theme-btn-lite">select</span>
            </div>
          </a>
        </li>
        <!-- Unsplash image -->
      </ul>
    </div>
  </div>
</template>
<script>
let delayTimer = null;
import Constants from "../constants/Constants.js";
export default {
  name: "SplashModal",
  components: { Constants },
  props: {},
  data: function () {
    return {
      unsplashSearch: "",
      unsplash: null,
    };
  },
  mounted: function () {
    this.loadUnsplash();
  },
  methods: {
    handleClick(imageUrl) {
      // Emit the event to the parent
      this.$emit("select-image", imageUrl);
    },
    async loadUnsplash() {
      await fetch(
        `https://api.unsplash.com/photos/?page=1&orientation=squarish&client_id=${Constants.UNSPLASHCLIENTID}`
      )
        .then((res) => res.json())
        .then((data) => {
          this.unsplash = data;
        })
        .catch((err) => console.log(err.message));
    },
    searchUnsplash() {
      $("#unsplashApiSearchLoader").removeClass("hidden");
      clearTimeout(delayTimer);
      let that = this;
      delayTimer = setTimeout(function () {
        if (that.unsplashSearch) {
          that.unsplash = null;
          fetch(
            `https://api.unsplash.com/search/photos/?page=1&orientation=squarish&client_id=${Constants.UNSPLASHCLIENTID}&query=${that.unsplashSearch}`
          )
            .then((res) => res.json())
            .then((data) => {
              that.unsplash = data.results;
              $("#unsplashApiSearchLoader").addClass("hidden");
            })
            .catch((err) => console.log(err.message));
        } else {
          $("#unsplashApiSearchLoader").addClass("hidden");
        }
      }, 1500);
    },
  },
  computed: {
    usplashData() {
      return this.unsplash;
    },
  },
};
</script>
